<template>
  <div>
    <section>
      <v-container container--fluid grid-list-xl>
        <v-row align="center">
          <v-col cols="12" :class="{'text-center': $vuetify.breakpoint.smAndDown}">
            <h1>Search Deliveries</h1>
          </v-col>
        </v-row>

        <v-row align="center" justify="space-around" class="my-8" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
          <v-col md="4" sm="10" cols="12" v-if="trackingSeen">
            <transition name="slide-y-transition">
              <v-text-field
                placeholder="Tracking No Or Serial No..."
                v-model="filters.tracking"
                prepend-icon="fas fa-box-open"
                @blur="showFieldsTrack"
                @click="dateSeen=false; siteSeen=false; invoiceSeen=false; regionSeen=false; invoiceOr=false"
                v-on:keyup.enter="getStops"
              ></v-text-field>
            </transition>
          </v-col>

          <div v-if="invoiceOr" class="light-blue-becool">
            OR
          </div>

          <v-col md="4" sm="10" cols="12" v-if="invoiceSeen">
            <transition name="slide-y-transition">
              <v-text-field
                placeholder="Invoice No..."
                v-model="filters.invoice"
                prepend-icon="fas fa-briefcase"
                @blur="showFieldsInvoice"
                @click="trackingSeen=false; siteSeen=false; invoiceOr=false"
                v-on:keyup.enter="getStops"
              ></v-text-field>
            </transition>
          </v-col>

          <div v-if="invoiceOr && $vuetify.breakpoint.smAndDown" class="light-blue-becool">
            OR
          </div>

          <v-col md="4" sm="10" cols="12" v-if="siteSeen">
            <transition name="slide-y-transition">
              <v-autocomplete
                clearable
                :items="clients"
                v-model="clientId"
                item-text="name"
                item-value="id"
                label="Pick a client name"
                prepend-icon="fas fa-user"
                :menu-props="{transition: 'slide-x-transition'}"
                :class="isInternalUser() ? 'd-flex': 'd-none'"
                @focus="trackingSeen=false; dateSeen=false; invoiceSeen=false; invoiceOr=false;"
              >
              </v-autocomplete>
            </transition>
            <transition name="slide-y-transition">
              <v-autocomplete
                clearable
                :disabled = "typeof(clientId) === 'undefined' && isInternalUser()"
                :items="renderedSuggestedSiteNames"
                :search-input.sync="siteNamesSelected"
                v-model="site"
                item-text="name"
                item-value="id"
                label="Pick a site name"
                prepend-icon="far fa-user"
                :menu-props="{transition: 'slide-x-transition'}"
                @focus="trackingSeen=false; dateSeen=false; invoiceSeen=false; invoiceOr=false;"
              >
              </v-autocomplete>
            </transition>
          </v-col>

          <div v-if="invoiceOr" class="light-blue-becool">
            OR
          </div>


          <v-col align="center" md="4" sm="10" cols="12" v-if="dateSeen && !(!trackingSeen && invoiceSeen)">
            <transition name="slide-y-transition">
              <v-row class="flex-column">
                <v-col col="12">
                  <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="filters.date"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="filters.date"
                        label="Routes Date"
                        prepend-icon="fas fa-calendar"
                        readonly
                        @focus="trackingSeen=false; invoiceSeen=false; siteSeen=false; invoiceOr=false"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="filters.date" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="blue darken-1"
                             @click="modal=false; trackingSeen=true; invoiceSeen=true; siteSeen=true; invoiceOr=true">
                        Cancel
                      </v-btn>
                      <v-btn text color="blue darken-1" @click="$refs.dialog.save(filters.date)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>

                  <v-autocomplete
                    v-model="filters.region"
                    :items="regions"
                    item-text="name"
                    item-value="id"
                    menu-props="auto"
                    label="Select a Region"
                    hide-details
                    prepend-icon="fas fa-map"
                    single-line
                    auto-select-first
                    :menu-props="{transition: 'slide-x-transition'}"
                    @input="trackingSeen=false; invoiceSeen=false; invoiceOr=false; siteSeen=false"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </transition>
          </v-col>

        </v-row>

        <v-row justify="center" class="mt-10">
          <v-col md="3" sm="12" cols="12">
            <v-btn text block color="blue-grey lighten-2" @click="clearFields">Clear</v-btn>
          </v-col>
          <v-col md="3" sm="12" cols="12">
            <v-btn text outlined block color="indigo" @click="getStops">Search</v-btn>
          </v-col>
        </v-row>

      </v-container>
    </section>

    <!--    <v-img :src="require('../../../assets/delivery-no-background.png')"></v-img>-->

    <section>
      <StopDataTable
        id="stopTable"
        ref="table"
        :search-bar="searchBar"
        :stops="stops"
        :alert="alert"
        :key="keyDataTable"
        :switch-param="pendingSwitch"
      ></StopDataTable>
    </section>

    <v-snackbar
      v-model="snackbar"
      bottom
      :timeout="3000"
      class="snackbar text-center"
    >
      {{message}}
      <v-btn
        color="blue darken-1"
        text
        @click="snackbar=false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
    import axios from 'axios'
    import StopDataTable from "./StopDataTable";

    // @vuese
    // Header used to look for a specific delivery.
    // @group Search
    export default {
        name: "SearchYourDelivery",
        components: {StopDataTable},
        data() {
            return {
                filters: {
                    tracking: '',
                    userNo: '',
                    name: '',
                    invoice: '',
                    region: null,
                    date: '',
                },
                scrollingOptions: {
                    offset: 0,
                    duration: 1000,
                    easing: 'easeInOutCubic'
                },
                dateClick: false,
                trackingSeen: true,
                regionSeen: true,
                invoiceSeen: true,
                invoiceOr: true,
                siteSeen: true,
                dateSeen: true,
                // filledFields: {},
                searchBar: false,
                searchClick: false,
                stops: [],
                status: null,
                // mapSeen: false,
                // alertMap: false,
                alert: false,
                boxInfo: null,
                snackbar: false,
                admin: false,
                markers: [],
                message: '',
                showInfo: false,
                modal: false,
                keyDataTable: 0,
                pendingSwitch: false,
                selectedTrackingNumber: null,
                deliveryInfo: null,
                scrollValue: null,
                siteNamesSelected: null,
                site: '',
                clientId: undefined
            }
        },
        methods: {
            // @vuese
            // Deletes a particular item from the stops array without making any API call.
            // @arg Takes a delivery/stop Object as an argument.
            deleteDelivery(item) {
                const index = this.stops.indexOf(item);
                this.stops.splice(index, 1);
            },
            // @vuese
            // Toggles DeliveryInfoDisplayer
            toggleInfoDisplayer() {
                this.showInfo = !this.showInfo
            },
            // @vuese
            // Displays a message in a snackbar.
            // @arg Takes a string message to be displayed in a snackbar.
            snackbarMessage(snackbar) {
                this.snackbar = true;
                if (snackbar === 'time') {
                    this.message = 'You just changed the time window of your delivery (Tracking: ' + this.selectedTrackingNumber + ') to " '
                        + this.newTimeWindow + '" !';
                } else if (snackbar === 'address') {
                    this.message = 'You just changed the address of your delivery (Tracking: ' + this.selectedTrackingNumber +
                        ') to ' + this.address + ' !';
                } else if (snackbar === 'cancel') {
                    this.message = 'You canceled the delivery #' + this.boxInfo.tracking + ' !';
                } else {
                    this.message = snackbar;
                }
            },
            // @vuese
            // Gets all the stops/deliveries from a specific tracking number
            getStopsFromTracking() {
                axios.get(process.env.API_URL + '/deliveries', {
                    params: {'tracking': this.filters.tracking.trim()}
                }).then((response) => {
                    if (response.status === 200) {
                        this.stops = response.data;
                        this.pendingSwitch = (this.stops[0].status === 'Pending');
                        this.searchBar = false;
                        this.keyDataTable += 1;
                    } else {
                        this.stops = [];
                        this.searchBar = false;
                        this.alert = true;
                    }
                    this.$vuetify.goTo(this.$refs.table, this.scrollingOptions)
                }).catch(() => {
                    this.searchBar = false;
                })
            },
            getStopsFromSites(){
                axios.get( process.env.API_URL + '/sites/' + this.site + '/deliveries')
                    .then((response) => {
                        if (response.status === 200) {
                            this.stops = response.data;
                            this.searchBar = false;
                            this.keyDataTable += 1;
                        } else {
                            this.stops = [];
                            this.searchBar = false;
                            this.alert = true;
                        }
                        this.$vuetify.goTo(this.$refs.table, this.scrollingOptions)
                    })
                    .catch(() => {
                        this.alert = false;
                        this.searchBar = false;
                        this.stops = [];
                    })
            },
            // @vuese
            // Gets all the stops/deliveries from the date/region parameters that have been filled by the user
            getStopsFromParams(parameters) {
                axios.get(process.env.API_URL + '/deliveries', {
                    params: parameters,
                }).then((response) => {
                    if (response.status === 200) {
                        this.stops = response.data;
                        this.searchBar = false;
                        this.keyDataTable += 1;
                    } else {
                        this.stops = [];
                        this.searchBar = false;
                        this.alert = true;
                    }
                    this.$vuetify.goTo(this.$refs.table, this.scrollingOptions)
                })
                    .catch(() => {
                        this.alert = false;
                        this.searchBar = false;
                        this.stops = [];
                    })
            },
            // @vuese
            // Gets all the stops corresponding to the user's research.
            getStops() {
                this.alert = false;
                this.boxClick = false;
                this.searchClick = true;
                this.searchBar = true;
                this.query = true;
                this.stops = [];
                if (Object.keys(this.filledFields).includes('tracking')) {
                    this.getStopsFromTracking();
                } else if ( this.site !== '' ){
                    this.getStopsFromSites();
                } else {
                    let filled = this.filledFields;
                    if ((Object.keys(filled).includes('date') && !Object.keys(filled).includes('region'))
                        || (!Object.keys(filled).includes('date') && Object.keys(filled).includes('region'))) {
                        this.snackbarMessage('Make sure you fill the date AND region fields');
                        this.searchBar = false;
                    } else {
                        // this.filledFields = filled;
                        this.getStopsFromParams(this.filledFields);
                    }
                }
            },
            getClients() {
                axios.get(process.env.API_URL + '/clients?inactive=true')
                    .then((response) => {
                        this.clients = response.data;
                    })
                    .catch((error) => {
                        console.log(error.response.error);
                  })
            },
            // @vuese
            // Shows all the fields if the tracking field is empty
            showFieldsTrack() {
                if (this.filters.tracking.length === 0) {
                    this.trackingSeen = true;
                    this.regionSeen = true;
                    this.siteSeen = true;
                    this.invoiceSeen = true;
                    this.dateSeen = true;
                    this.invoiceOr = true;
                }
            },
            // @vuese
            // Shows the tracking field if the invoice field is empty and hides it if invoice field is filled.
            showFieldsInvoice() {
                if (this.filters.invoice.length === 0) {
                    this.trackingSeen = true;
                    this.regionSeen = true;
                    this.siteSeen = true;
                    this.invoiceSeen = true;
                    this.dateSeen = true;
                    this.invoiceOr = true;

                // } else {
                //     this.trackingSeen = false;
                //     this.invoiceOr = false;
                }
            },
            // @vuese
            // Hides the tracking if any of the region, date or invoice field is filled.
            showFieldsDate() {
                this.dateClick = !this.dateClick;
                if ((this.filters.date.length === 0) && (this.filters.invoice.length === 0) && (this.filters.region.length === 0)) {
                    this.trackingSeen = true;
                    this.invoiceOr = true;
                } else {
                    this.invoiceOr = false;
                    this.trackingSeen = false;
                }
            },
            // @vuese
            // Clears all the fields values and resets them to default.
            clearFields() {
                this.filters = {
                    tracking: '',
                    userNo: '',
                    name: '',
                    invoice: '',
                    region: '',
                    date: '',
                };
                this.site = '';
                this.clientId = undefined;
                this.trackingSeen = true;
                this.regionSeen = true;
                this.invoiceSeen = true;
                this.invoiceOr = true;
                this.siteSeen = true;
                this.dateSeen = true;
                this.searchClick = !this.searchClick;
                this.alert = false;
                this.stops = [];
            },

            isInternalUser() {
                return this.$store.getters['auth/isInternalUser'];
            },
        },
        computed: {
            // Returns an Object containing the filled fields.
            filledFields() {
                let filled = {};
                for (var key of Object.keys(this.filters)) {
                    if (this.filters[key] !== null && this.filters[key] !== undefined && this.filters[key] !== '') {
                        if (this.filters[key].length != 0) {
                            if (key === 'region') {
                                filled[key] = this.filters[key];
                            } else {
                                filled[key] = this.filters[key].trim();
                            }
                        }
                    }
                }
                return filled
            },
            regions() {
              return this.$store.getters['auth/permissionRegions']('delivery_view');
            },
            renderedSuggestedSiteNames() {
              if (this.suggestedSiteNames === undefined) return [];
              return this.suggestedSiteNames;
            }
        },
        asyncComputed: {
            async suggestedSiteNames() {
                if (this.siteNamesSelected !== null ) {
                    let url =
                      '/sites/search?client_id=' +
                      (this.$store.getters['auth/isInternalUser'] ? this.clientId : this.$store.getters['auth/client_id']); //determine the client id
                    if ( this.siteNamesSelected.length > 2 ){
                        url = url + '&name=' + this.siteNamesSelected;
                    }
                    return await axios.get(process.env.API_URL + url )
                        .then((response) => {
                            if (response.status === 200) {
                                return response.data;
                            }
                        })
                        .catch((error) => {
                            return [];
                        })

                }
            },
          async clients() {
            if (this.$store.getters['auth/isInternalUser'] || !this.$store.getters['auth/isInternalUser']) {
              return await axios.get(process.env.API_URL + '/clients')
                  .then((response) => {
                    return response.data;
                  })
                  .catch((error) => {
                    console.log(error.response.error);
                  })
            }
          }
        },
        mounted() {
            if (this.$route.query.tracking !== null && this.$route.query.tracking !== undefined) {
                this.filters.tracking = this.$route.query.tracking;
                this.getStops();
            } else if (this.$route.query.invoice !== null && this.$route.query.invoice !== undefined) {
                this.filters.invoice = this.$route.query.invoice;
                this.getStops();
            }

            if (this.filters.tracking.length != 0) {
                this.regionSeen = false;
                this.siteSeen = false;
                this.invoiceSeen = false;
                this.dateSeen = false;
                this.invoiceOr = false;
            }
        },
    }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Search/SearchYourDelivery.vue